/* eslint react/no-unused-prop-types: 'off' */
/* eslint jsx-a11y/interactive-supports-focus: 'off' */
/* eslint jsx-a11y/no-autofocus: 'off' */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { forwardRef, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MenuItem } from 'react-bootstrap';

const List = forwardRef(
  (
    {
      listRefs,
      filteredOptions,
      inputValue,
      selected,
      preselectFirst,
      toggleText,
      focusedIndex,
      showOptionId,
      listMaxHeight,
      onSelectValue,
      onToggleClose,
    },
    ref,
  ) => (
    <ul ref={ref} className="dropdown-menu__inner" style={{ maxHeight: `${listMaxHeight}px` }}>
      {!preselectFirst && inputValue === '' && (
        <>
          <li
            className={classNames('dropdown-header-select', {
              'not-empty': selected || focusedIndex !== -1,
            })}
          >
            <a href="# " onClick={(e) => e.preventDefault()}>
              {toggleText}
            </a>
          </li>
        </>
      )}
      {!filteredOptions.length ? (
        <li className="menu-item-no_result">
          <a href="# " onClick={(e) => e.preventDefault()}>
            No results matched
            {' '}
            {inputValue && `"${inputValue}"`}
          </a>
        </li>
      ) : null}
      {filteredOptions?.map((elem, index) => (
        <Fragment key={index}>
          {elem?.isGroupHeader ? (
            <div>
              {index !== 0 ? <MenuItem divider /> : null}
              <li className="dropdown-header">
                <span>{elem.title}</span>
              </li>
            </div>
          ) : (
            <li
              ref={listRefs[index]}
              onClick={(e) => {
                e.preventDefault();
                onSelectValue(elem, index);
                onToggleClose();
              }}
              className={classNames('menu-item', {
                selected: focusedIndex === index,
              })}
            >
              <a href="# " role="button" className={focusedIndex === index ? 'active' : ''}>
                {showOptionId && <span className="select-id">{elem.id}</span>}
                <span>{elem.title}</span>
              </a>
            </li>
          )}
        </Fragment>
      ))}
    </ul>
  ),
);

List.propTypes = {
  listRefs: PropTypes.object,
  filteredOptions: PropTypes.array,
  inputValue: PropTypes.string,
  selected: PropTypes.object,
  preselectFirst: PropTypes.bool,
  focusedIndex: PropTypes.number,
  showOptionId: PropTypes.bool,
  toggleText: PropTypes.string,
  listMaxHeight: PropTypes.number,
  onSelectValue: PropTypes.func,
  onToggleClose: PropTypes.func,
};

export default List;
